import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://lbyphntebsmwdozqimec.supabase.co'
const supabaseKey = "sb_publishable_VZHWRA4yUFtUJ7tw_fzbHg_2aD_rW91"
export const supabase = createClient(supabaseUrl, supabaseKey)